import { useField } from 'formik';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 'auto',
	},
	outlinedStyle: {
		padding: theme.spacing(1),
	},
}));

const GMSelect = (props) => {
	const { label, data } = props;
	const classes = useStyles();
	const [field, meta] = useField(props);

	useEffect(() => {
		console.log('GMSelect useEffect once', field, meta);
	}, []);

	// useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
	// which we can spread on <input> and alse replace ErrorMessage entirely.
	const { id, name } = props;
	return (
		<div className={`control ${classes.root}`}>
			{label && <label htmlFor={id || name}>{label}</label>}
			<Select
				variant="outlined"
				classes={{ outlined: classes.outlinedStyle }}
				{...field}
				{...props}
			>
				{data.map((item) => {
					const { name, value } = item;
					return (
						<MenuItem value={value} key={uid(item)}>
							{name}
						</MenuItem>
					);
				})}
			</Select>

			{meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
		</div>
	);
};

GMSelect.propTypes = {
	label: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.array,
	name: PropTypes.string,
};

export default GMSelect;
